const images = {
  default: require('./default-profile.jpg'),
};

export default images;
